export type ExamType = '1zi' | '2zi';

export interface Subject {
  id: string;
  name: string;
  examType: ExamType;
}

export const firstExamSubjects: Subject[] = [
  { id: 'economics', name: '経済学・経済政策', examType: '1zi' },
  { id: 'finance', name: '財務・会計', examType: '1zi' },
  { id: 'management', name: '企業経営理論', examType: '1zi' },
  { id: 'operations', name: '運営管理', examType: '1zi' },
  { id: 'law', name: '経営法務', examType: '1zi' },
  { id: 'information', name: '経営情報システム', examType: '1zi' },
  // 本番の exam_questions の科目IDは 'policy'。ここが 'sme' だったため、
  // 学習ヒートマップ・Analytics・苦手分野が**中小企業経営・政策の解答を1件も数えられていなかった**
  // （実測: この科目だけ解答した人の連続学習日が 0 日）。2026-09-26 修正。
  { id: 'policy', name: '中小企業経営・中小企業政策', examType: '1zi' },
];

export const secondExamSubjects: Subject[] = [
  { id: 'case_1', name: '事例Ⅰ', examType: '2zi' },
  { id: 'case_2', name: '事例Ⅱ', examType: '2zi' },
  { id: 'case_3', name: '事例Ⅲ', examType: '2zi' },
  { id: 'case_4', name: '事例Ⅳ', examType: '2zi' },
];

export const subjects: Subject[] = [
  ...firstExamSubjects,
  ...secondExamSubjects,
];

export const subjectNames: Record<string, string> = subjects.reduce(
  (acc, cur) => {
    acc[cur.id] = cur.name;
    return acc;
  },
  {} as Record<string, string>
);

// より鮮明で識別しやすい科目カラー
export const subjectBgColorMap: Record<string, string> = {
  economics: '#F59E0B',   // アンバー
  finance: '#10B981',     // エメラルドグリーン
  management: '#EC4899',  // ピンク
  operations: '#22C55E',  // グリーン
  law: '#EF4444',         // レッド
  information: '#3B82F6', // ブルー
  policy: '#F97316',      // オレンジ
  case_1: '#8B5CF6',      // パープル
  case_2: '#EAB308',      // イエロー
  case_3: '#6366F1',      // インディゴ
  case_4: '#FB923C',      // オレンジライト
};
